var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.itemRow.duplicate === 1)?_c('span',{staticClass:"badge",class:{
      'badge-soft-pdp': this.itemRow.duplicate === 1,
    }},[_vm._v("Has Duplicate")]):(this.itemRow.duplicate === 0)?_c('span',{staticClass:"badge",class:{
      'badge-soft-warning': this.itemRow.duplicate === 0,
    }},[_vm._v("It has no duplicate")]):_vm._e(),(this.itemRow.duplicate === 2)?_c('span',{staticClass:"badge",class:{
      'badge-soft-info': this.itemRow.duplicate === 2,
    }},[_vm._v("Duplicated")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }